var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,8.25V10.5h-9V8.25H0V10.5A1.5,1.5,0,0,0,1.5,12h9A1.51,1.51,0,0,0,12,10.5V8.25ZM2.25,3.75,3.31,4.81,5.25,2.87V9h1.5V2.87L8.69,4.81,9.75,3.75,6,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileUpload);
export default __webpack_public_path__ + "static/media/icon-file-upload.0329b69326487dbf260290cbb0296065.svg";
export { ForwardRef as ReactComponent };